import { IAttribute } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { SapC4CResourceDataset } from 'app/model/dataset/sapc4c-resource.dataset';
import { TabularCopySource } from './tabular-type.copysource';

import { Constants } from 'app/shared/shared-constants';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.sapc4c.copySourceType,
    display: [],
    tags: {
        datasetModel: [
            Metamodel.modelFor(SapC4CResourceDataset)
        ]
    }
})
export class SapC4CCopySource extends TabularCopySource {
    public static readonly HTTP_REQUEST_TIMEOUT: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'HTTP_REQUEST_TIMEOUT',
        display: `${stringResources.ModelName_Request_Timeout}`,
        constraint: {
            pattern: Constants.timeoutValidation
        }
    })
    public httpRequestTimeout?: string = '00:05:00';
}
